export function getLinkFooter(id, label, url) {
  const href = url ? encodeURI(url) : '#';
  return `<a ec-padding="" ec-hover="" href="${href}" view-name="${id}">${edicom.locale.translate(label)}</a>`;
}
